import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/blocks/BeforeAfterShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.4.8_@opentelemetry+api@1.9.0_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/app-dir/link.js");
